// extracted by mini-css-extract-plugin
export default {"slider-container":"EventDetails_slider-container__DD8B-","photo":"EventDetails_photo__UI7we","flexElem":"EventDetails_flexElem__HZ7Qj"};